<template>
  <div id="content" class="row g-2 justify-content-center">
    <h1 class="col-xxl-7 col-xl-8 col-lg-9 mb-2">Gespeicherte Verbindungen</h1>
  </div>
  <div class="row g-2 justify-content-center">
    <div class="col-xxl-7 col-xl-8 col-lg-9 mb-5">
      <div v-if="availableSortedDates.length > 0" v-for="date in availableSortedDates">
        <div>
          <h3 class="mt-5">{{ date }}</h3>
          <div v-for="key in groupByDateSortByTime[date]">
            <journey-card
              :journey="savedJourneys[key]"
              :key="key"
              :showHeader="true"
            ></journey-card>
          </div>
        </div>
      </div>
      <div v-else>Du hast keine Verbindungen gespeichert</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { getJourneyDeparture } from '~/utils/fptfHelpers'
import JourneyCard from '~/components/JourneyDisplay/JourneyCard.vue'
import dayjs from 'dayjs'

const store = useMainStore()
const { savedJourneys } = storeToRefs(store)

const groupByDateSortByTime = computed(() => {
  let groups: { [index: string]: string[] } = {}
  for (const key of Object.keys(savedJourneys.value)) {
    const date = getDate(key)
    if (date in groups) {
      groups[date].push(key)
    } else {
      groups[date] = [key]
    }
  }
  for (const date in groups) {
    groups[date].sort((a, b) => {
      const departureA = getJourneyDeparture(savedJourneys.value[a])
      const departureATime = departureA.plannedTime ? departureA.plannedTime : departureA.time
      const departureB = getJourneyDeparture(savedJourneys.value[b])
      const departureBTime = departureB.plannedTime ? departureB.plannedTime : departureB.time
      return departureATime.isBefore(departureBTime) ? -1 : 1
    })
  }
  return groups
})

const availableSortedDates = computed(() => {
  return Object.keys(groupByDateSortByTime.value).sort((a, b) => {
    const dateA = dayjs(a, 'DD.MM.YYYY')
    const dateB = dayjs(b, 'DD.MM.YYYY')
    return dateA.isBefore(dateB) ? -1 : 1
  })
})

function getDate(key: string) {
  const times = getJourneyDeparture(savedJourneys.value[key])
  return times.plannedTime
    ? times.plannedTime.format('DD.MM.YYYY')
    : times.time.format('DD.MM.YYYY')
}
</script>
